const {useEffect, useState} = require('react');

/**
 * find the lowest price in variation
 *
 * @param {array} variations
 * @param {number} price
 */
const findLowerPrice = (variations, price) => {
  if (variations && variations[0]) {
    const reducer = (min, v) => {
      if (
        v.price !== undefined &&
        +v.price > 0 &&
        (+v.price < min || min === 0)
      ) {
        return +v.price;
      }
      return min;
    };
    return variations.reduce(reducer, 0);
  }
  return price;
};

export const useStock = props => {
  const {store, id, price, variations, unit, quantity} = props;
  // get stock for this products
  const [_stock, setStock] = useState();
  // update price on change variations
  const [_price, setPrice] = useState(price);
  // set minPrice from variations
  const [minPrice, setMinPrice] = useState(null);
  // option selected if variations
  const [_option, setOption] = useState(null);
  const [_unit, setUnit] = useState(unit);
  const [_quantity, setQuantity] = useState(quantity);

  useEffect(() => {
    const _prod = store.stock.find(e => e.id === id);
    if (_prod) {
      setStock(_prod.stock);
    }
    if (variations && variations[0]) {
      // set the first option price
      setPrice(variations[0].price ? +price + +variations[0].price : price);
      // set the first option
      setOption(variations && variations[0] ? variations[0].label : null);
      setUnit(variations && variations[0] ? variations[0].unit : null);
      setQuantity(variations && variations[0] ? variations[0].quantity : null);
      // find min price if variations
      setMinPrice(findLowerPrice(variations, price));
    }
  }, [store, id, price, variations]);

  useEffect(() => {
    if (!_option && store.stock.length < 1) return;
    const findOption = store.stock.find(e => {
      return e.id === `${id}|${_option}`;
    });
    if (findOption) {
      setStock(
        findOption.stock && findOption.stock !== 'null'
          ? +findOption.stock
          : undefined,
      );
    }
  }, [store, _option, id]);

  let customOptions = null;
  if (variations) {
    customOptions = '';
    variations.forEach(v => {
      customOptions += `${v.label}${v.price ? `[+${v.price}]` : ''}|`;
    });
  }
  return {
    customOptions,
    _stock,
    _option,
    setPrice,
    setOption,
    minPrice,
    _price,
    _unit,
    setUnit,
    _quantity,
    setQuantity,
  };
};
